import { importWhenVisible, Base } from '@studiometa/js-toolkit';
import LargeText from '../atoms/LargeText.js';

/**
 * Experience component
 */
export default class Experience extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Experience',
    components: {
      GeoPinsMap: (app) =>
        importWhenVisible(() => import('./GeoPinsMap/index.js'), 'GeoPinsMap', app),
      Quizz: (app) => importWhenVisible(() => import('../molecules/Quizz/Quizz.js'), 'Quizz', app),
      LargeText,
      ImagesGrid: (app) =>
        importWhenVisible(() => import('../molecules/ImagesGrid/ImagesGrid.js'), 'ImagesGrid', app),
      AromaMap: (app) =>
        importWhenVisible(() => import('../molecules/AromaMap/AromaMap.js'), 'AromaMap', app),
    },
  };
}
